import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PrintService {
  constructor() { }

  print(file) {
    const binary = atob(file.documento);
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    const view = new Uint8Array(buffer);
    for (let j = 0; j < len; j ++) {
      view[j] = binary.charCodeAt(j);
    }
    const blob = new Blob([view], { type: 'application/pdf'});
    const url = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }

  printSale(labelsTemplate: string): Promise<any> {
    return new Promise(resolve => {
      const frame1: any = document.createElement('iframe');
      frame1.name = 'frame3';
      frame1.style.position = 'absolute';
      frame1.style.top = '-1000000px';
      document.body.appendChild(frame1);
      const frameDoc: any = frame1.contentWindow
        ? frame1.contentWindow
        : frame1.contentDocument.document
          ? frame1.contentDocument.document
          : frame1.contentDocument;
      frameDoc.document.open();
      frameDoc.document.write(`<html>
                                <head>
                                  <title>Print tab</title>
                                  <style>
                                    // -------
                                  </style>
                                </head>
                                <body>`);
      frameDoc.document.write(labelsTemplate);
      frameDoc.document.write('</body></html>');
      frameDoc.document.cookie = 'Set-Cookie: key=value; SameSite=Strict';
      frameDoc.document.close();
      setTimeout(function () {
        window.frames['frame3'].focus();
        window.frames['frame3'].print();
        document.body.removeChild(frame1);
      }, 500);
      frameDoc.onunload = e => {
        resolve(true);
      };
    });
  }

  printDocument(html, name: String) {
    const printPage = window.open(
      '',
      `${name}`,
      'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=' +
      screen.width +
      ',height=' +
      screen.height +
      ',top=0,left=0',
    );
    printPage.document.open();
    printPage.document.write(`
      <html>
        <head>
          <style>
          </style>
        </head>
        <body onload="window.print();window.close()">${html}</body>
      </html>`);
    printPage.document.close();
  }

  printCustomerGuide(labelsTemplate: string): Promise<any> {
    return new Promise(resolve => {
      const frame1: any = document.createElement('iframe');
      frame1.name = 'frame3';
      frame1.style.position = 'absolute';
      frame1.style.top = '-1000000px';
      document.body.appendChild(frame1);
      const frameDoc: any = frame1.contentWindow
        ? frame1.contentWindow
        : frame1.contentDocument.document
        ? frame1.contentDocument.document
        : frame1.contentDocument;
      frameDoc.document.open();
      frameDoc.document.write(`<html>
                                <head>
                                  <title>Print tab</title>
                                  <style>
                                  body {
                                    -webkit-print-color-adjust: exact;
                                  }
                                  .table-bordered thead tr {
                                    border-bottom-width: 2px;
                                  }

                                  .table-bordered tr {
                                    border-bottom: 1px solid #e1e1e1;
                                    border-left: 1px solid #e1e1e1;
                                    border-right: 1px solid #e1e1e1;
                                  }

                                  .table {
                                    width: 100%;
                                    max-width: 100%;
                                    margin-bottom: 2em;
                                    background-color: #fff;
                                    border: 0;
                                    border-collapse: collapse;
                                    font-family: "RobotoDraft", "Roboto", "Helvetica Neue, Helvetica, Arial",
                                      sans-serif;
                                    color: #212121;
                                  }

                                  .table th,
                                  .table td {
                                    text-align: left;
                                    padding: 1.6em;
                                    vertical-align: center;
                                    border: inherit;
                                  }

                                  .table thead tr {
                                    border-bottom: 1px solid #e1e1e1;
                                    border-left: 1px solid #e1e1e1;
                                    border-right: 1px solid #e1e1e1;
                                  }

                                  .table thead th {
                                    font-weight: 400;
                                    color: #3f3f3f;
                                    vertical-align: center;
                                  }

                                  .logo {
                                    width: 20%;
                                    height: 45px;
                                    background-repeat: no-repeat !important;
                                    -webkit-print-color-adjust: exact;
                                  }

                                  .OE {
                                    background: url("data:image/png;base64,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");
                                  }

                                  .PRO {
                                    background: url("data:image/png;base64,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");
                                  }

                                  .SPSA {
                                    background: url("data:image/png;base64,");
                                    width: 500px;
                                  }

                                  .RP {
                                    background: url("data:image/jpeg;base64,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");
                                    min-width: 265px !important;
                                  }

                                  .content-header {
                                    width: 100%;
                                    display: inline-flex;
                                  }

                                  .inStore {
                                    font-weight: bold;
                                    font-size: 16px;
                                    width: 80%;
                                    text-align: left;
                                  }

                                  .content-info-client {
                                    border-radius: 6px;
                                  }

                                  .content-info-client {
                                    padding: 0px 10px 10px 10px;
                                  }

                                  .number {
                                    float: right;
                                  }

                                  .text-one,
                                  .text-two {
                                    font-weight: bold;
                                  }

                                  .text{
                                    font-weight: normal;
                                  }

                                  .data-client {
                                    font-weight: bold;
                                    margin: 6px 0;
                                    font-family: sans-serif;
                                  }

                                  .text-one {
                                    width: 28%;
                                    min-width: 28%;
                                  }

                                  .content-info {
                                    width: 100%;
                                    display: flex;
                                  }

                                  .width-50 {
                                    width: 50%;
                                    padding-right: 10px;
                                    padding-top: 10px;
                                  }

                                  .width-60 {
                                    width: 60%;
                                  }

                                  .width-80 {
                                    width: 80%;
                                  }

                                  .width-100 {
                                    width: 100%;
                                  }

                                  .width-25 {
                                    width: 25%;
                                  }

                                  .info {
                                    padding: 3px;
                                  }

                                  thead {
                                    border-radius: 10px !important;
                                  }

                                  .products {
                                    color: white !important;
                                    font-weight: bold !important;
                                  }

                                  th,
                                  td {
                                    height: 10px !important;
                                    padding: 10px !important;
                                  }

                                  .content-price {
                                    padding-left: 10px;
                                  }

                                  .total {
                                    font-weight: bold;
                                  }

                                  .text-two {
                                    font-weight: bold;
                                    width: 27%;
                                    min-width: 27%;
                                  }

                                  .text-danger {
                                    color: #8d1205;
                                  }

                                  table {
                                    font-size: 10px !important;
                                  }

                                  .info {
                                    width: 100%;
                                    font-family: sans-serif;
                                    display: inline-flex;
                                    font-size: 12px !important;
                                    /*  padding: 1px 0; */
                                    word-break: break-word;
                                    text-align: justify;
                                  }

                                  body {
                                    -webkit-print-color-adjust: exact;
                                  }

                                  @page {
                                    size: A4;
                                    /* auto is the initial value */
                                    margin: 3mm 2mm 2mm 2mm;
                                  }

                                  table.report-container{
                                    page-break-after: always;
                                  }

                                  thead.report-header {
                                    display: table-header-group;
                                  }

                                  tr td {
                                    word-break: break-word !important;
                                  }

                                  .description {
                                    width: 550px;
                                  }

                                  .logo {
                                    width: 160px !important;
                                  }

                                  .inStore {
                                    font-family: sans-serif;
                                    margin-top: 15px;
                                  }

                                  /* ================ NUEVAS LINEAS */

                                  .inStore {
                                    margin-top: 15px !important;
                                  }

                                  .PRO {
                                    margin-top: 7px;
                                  }

                                  .content-info-client {
                                    margin-top: 0px;
                                  }

                                  /* PARA LOS COLORES POR TIENDA */

                                  /* BORDE */
                                  .content-info-client-OE {
                                    border: 1px solid red !important;
                                  }

                                  .content-info-client-PRO {
                                    border: 1px solid #ec6b00 !important;
                                  }

                                  .content-info-client-SPSA {
                                    border: 1px solid #35783c !important;
                                  }

                                  .content-info-client-RP {
                                    margin-top: 8px;
                                    border: 2px solid #7300e0 !important;
                                  }

                                  /* TEXTO */
                                  .text-OE {
                                    color: red;
                                  }

                                  .text-PRO {
                                    color: #ec6b00;
                                  }

                                  .text-SPSA ::ng-deep {
                                    color: #35783c;
                                  }

                                  .text-RP {
                                    color: #7300e0;
                                  }

                                  /* BACKGROUND */
                                  .header-OE {
                                    background: red;
                                  }

                                  .header-PRO {
                                    background: #ec6b00;
                                  }

                                  .header-SPSA {
                                    background: #35783c;
                                  }

                                  .header-RP {
                                    background: white;
                                    color: #7300e0 !important;
                                  }

                                  .header-border-RP {
                                    border: 2px solid #7300e0 !important;
                                  }

                                  .firma {
                                    padding-top: 100px !important;
                                  }
                                  .firma-generic {
                                    text-align: center;
                                    width: 100%;
                                    display: inline-flex;
                                    padding-top: 60px;
                                  }
                                  .client {
                                    margin-left: 4%;
                                    width: 40%;
                                  }
                                  .userDispatch p {
                                    padding: 0 !important;
                                    margin: 0 !important;
                                  }

                                  .userDispatch {
                                      margin-left: 10%;
                                      width: 40%;
                                  }

                                  .userDispatch .name-user-dispatch {
                                      padding-top: 5px !important;
                                  }
                                  .observation {
                                    height: 100px;
                                  }
                                  .sumary {
                                    font-family: sans-serif;
                                    font-size: 12px;
                                    text-align: justify;
                                  }
                                  .content-info-list {
                                    display: flex;
                                    flex-wrap: wrap;
                                    font-family: sans-serif;
                                    font-size: 12px;
                                  }
                                  .content-info-list > div {
                                    padding: 6px 0px;
                                  }
                                  .mb {
                                    margin-bottom: 2rem;
                                  }
                                  .page-break {
                                    page-break-inside: avoid;
                                    page-break-after: auto;
                                    position: relative;
                                    display: block;
                                  }
                                  .text-table{
                                    margin: 6px;
                                    font-weight: bold;
                                    font-size: 14px;
                                  }
                                  .header-content{
                                    display: flex;
                                    justify-content: space-between;
                                  }
                                  </style>
                                </head>
                                <body>`);
      frameDoc.document.write(labelsTemplate);
      frameDoc.document.write('</body></html>');
      frameDoc.document.cookie = 'Set-Cookie: key=value; SameSite=Strict';
      frameDoc.document.close();
      setTimeout(function() {
        window.frames['frame3'].focus();
        window.frames['frame3'].print();
        document.body.removeChild(frame1);
      }, 500);
      frameDoc.onunload = e => {
        resolve(true);
      };
    });
  }
}
